const applicantConstants = {
  acceptDeclineApplicationShare: 'ACCPET_DECLINE_APPLICATION_SHARE',
  acceptDeclineApplicationShareSucceeded: 'ACCPET_DECLINE_APPLICATION_SHARE_SUCCEEDED',
  acceptDeclineApplicationShareFailed: 'ACCPET_DECLINE_APPLICATION_SHARE_FAILED',
};

export default applicantConstants;
